import { useCaseCreateForm } from "@/features/case/hooks/use-case-create-form";
import { CaseCreateFormLayout } from "@/features/case/components/CaseCreate/CaseCreateFormLayout";

export const CaseCreatePage = () => {
  const {
    methods,
    control,
    caseSchema,
    onSubmit,
    jobId,
    jobInfo,
    isLoadingJobInfo,
    activeStep,
    managementNumber,
    caseName,
    duplicateCaseModal,
    duplicateCases,
    pendingCaseName,
    handleDuplicateCaseModalCancel,
    handleNavigateBack,
  } = useCaseCreateForm();

  return (
    <CaseCreateFormLayout
      methods={methods}
      control={control}
      caseSchema={caseSchema}
      onSubmit={onSubmit}
      jobId={jobId}
      jobInfo={jobInfo}
      isLoadingJobInfo={isLoadingJobInfo}
      activeStep={activeStep}
      managementNumber={managementNumber}
      caseName={caseName}
      duplicateCaseModalOpen={duplicateCaseModal.open}
      duplicateCases={duplicateCases}
      pendingCaseName={pendingCaseName}
      onDuplicateCaseModalClose={handleDuplicateCaseModalCancel}
      onNavigateBack={handleNavigateBack}
    />
  );
};
